import { connect } from 'react-redux';
//
import AuthCallback from 'pages/auth-callback/auth-callback';
import { initializeApp, setUserIdClaimsName } from 'store/general/actions';

const mapDispatchToProps = {
  initializeApp,
  setUserIdClaimsName,
};

export default connect(null, mapDispatchToProps)(AuthCallback);
